/* Initialize */
var moreInfoElements = document.querySelectorAll('.product_details .more_info');

/* Listeners */
moreInfoElements.forEach((el)=>{
    el.addEventListener('click', (e)=>{
        var info = el.nextElementSibling;

        if($(el).find('i').attr('class') == 'arrow-up'){
          $(el).find('i').addClass('arrow-down').removeClass('arrow-up');
        }else{
          $(el).find('i').addClass('arrow-up').removeClass('arrow-down');
        }
        //$('.product_details .info').hide()
        $(info).slideToggle(300);
    })
})